import { CartLinesUpdateEvent } from '@shopify/events';

// Delegated handler survives the Tinker cart drawer's section morphs.
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-eir-upsell-form]')) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const status = form.closest('[data-eir-county-upsell]')?.querySelector('[data-eir-upsell-status]');
  if (!button || button.disabled) return;
  const variantId = Number(form.querySelector('input[name="id"]')?.value);
  if (!Number.isSafeInteger(variantId) || variantId <= 0) return;

  button.disabled = true;
  button.textContent = 'Adding…';
  if (status) status.textContent = '';
  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'cart',
    lines: [{ merchandiseId: String(variantId), quantity: 1 }],
    promise: deferred.promise
  }));

  let added = false;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map(el => el.dataset.sectionId).filter(Boolean))];
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({items: [{id: variantId, quantity: 1}], sections: sectionIds, sections_url: location.pathname})
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || 'Could not add item');
    added = true;

    const cartResponse = await fetch(root + 'cart.js', {credentials: 'same-origin', headers: {'Accept':'application/json'}});
    if (!cartResponse.ok) throw new Error('Unable to refresh cart');
    const cart = await cartResponse.json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        itemCount: cart.item_count,
        sections: result.sections,
        source: 'eir-county-cart-upsell',
        didError: false
      }
    });
    button.textContent = 'Added ✓';
    if (status) status.textContent = 'Added to your basket.';
  } catch (error) {
    deferred.reject(error);
    if (added) {
      location.reload();
      return;
    }
    if (status) status.textContent = error.message || 'Could not add item. Please try again.';
    button.textContent = '+ Add';
    button.disabled = false;
  }
});